import { Component, OnInit, Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ProductService } from "../../services/product.service";
import { Product } from "../../classes/product";
import { ApiCartService } from '../../api-services/cart.service';
import { faCartShopping, faTrash } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  public products: Product[] = [];
  public cart: any = null;
  public search: boolean = false;
  public faTrash = faTrash;
  public faCartShopping = faCartShopping;
  public innerWidth: any;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public productService: ProductService,
    private apiCartService: ApiCartService
  ) {
    
    this.apiCartService.cart.subscribe(
      (cart) => {
        if(cart != null) {
          this.cart = cart;
          this.products = cart.products;
        } else {
          this.cart = null;
          this.products = [];
        }
      }
    );
  }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
  }

  searchToggle(){
    this.search = !this.search;
  }

  changeLanguage(code){
  }

  removeItem(product: any) {
    this.apiCartService.removeProductToShoppingCart(product.product.id, product.size).subscribe();
  }

  changeCurrency(currency: any) {
    this.productService.Currency = currency
  }

  /**
     * Returns a number of the total price of cart (shipping cost not included)
     * 
     * @returns number
     */
  public getSubTotal(): number {
    let subTotal = 0;
    this.cart.products.forEach(
      (cartProduct: any) => {
        subTotal += cartProduct.product.price * cartProduct.quantity;
      }
    );

    return subTotal;
  }

}
